import React, {useEffect, useState} from 'react';
import { Box, } from '@mui/material';
import PageContent from './partials/PageContent'
import PageHeader from './partials/PageHeader'
import SEO from '../../common/SEO';
import { getPageSolutionHotelData } from "../../../services/pages";
import Preloader from '../../common/Preloader'; 
//import image from '../../../assets/images/soluciones_hoteles_data.png';
import AOS from 'aos';

const PageHotelsSolution = () => {
  
  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
  const [pageData, setPagesData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pageResponse,] = await Promise.all([ getPageSolutionHotelData(), ]);          
        setPagesData(pageResponse || {});
      } catch (error) {
        console.error("Error fetching data:", error.response || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) { return <Preloader />; }

  const { title, description, content, image } = pageData.page_hotel;

  //console.log('pageData', pageData)

  return (
    <Box className="solution-page" id="page-hotel">
      <SEO 
        title="Motor de Hoteles B2B | Búsqueda con mapa, filtros y comparador — E2E"
        description="Motor de hoteles para empresas de turismo: mapa interactivo, filtros por amenities, comparador y experiencia orientada a la conversión."
      />
      <PageHeader 
        title={title} 
        prev={'End to end Aéreos'}
        hrefPrev="/solutions/air"
        next="End to end Asistencia al viajero" 
        hrefNext="/solutions/assist" 
      />
      <PageContent 
        content={content} 
        title={title} 
        description={description} 
        image={image}
      /> 
    </Box>)
}

export default PageHotelsSolution;


